/* eslint-disable camelcase */
import axios from 'axios';
import {baseEnvironment} from '../environment/environment.base';

const v1Version = baseEnvironment.apiVersion1;
const v3Version = baseEnvironment.apiVersion3;
const usersAllRoute =  `/${v3Version}${baseEnvironment.apiEndPoints.users.all}`;
const usersRoute =  `/${v1Version}${baseEnvironment.apiEndPoints.users.users}`;
const usersAuditRoute =  `/${v1Version}${baseEnvironment.apiEndPoints.users.usersAudit}`;
const userUrl =  `${v3Version}/${baseEnvironment.apiEndPoints.users.me}`;
const modulesRoute =`${v3Version}${baseEnvironment.apiEndPoints.users.modules}`;
const v3UsersRoute =`${v3Version}${baseEnvironment.apiEndPoints.users.users}`;
/* Find all users */
export const getAllUsers = async (): Promise<any> => {
  const response = await axios.get(`${usersAllRoute}`);
  return response.data;
};

export const getUserInfo= async(): Promise<any> => {
  const response = await axios.get(userUrl);
  return response.data;
};

export const getModules = async (): Promise<any> => {
  const response = await axios.get(modulesRoute);
  return response.data;
};

export const createUser = async (payload: any): Promise<any> => {
  const response = await axios.post(v3UsersRoute, payload);
  return response.data;
};

export const updateUser = async (id: any, payload: any): Promise<any> => {
  const response = await axios.put(`${v3UsersRoute}/${id}`, payload);
  return response.data;
};

export const deleteUser = async (id: any): Promise<any> => {
  const response = await axios.delete(`${v3UsersRoute}/${id}`);
  return response.data;
};

/* Find update user type */
export const updateUserType = async (
  id: any,
  userObject: any
): Promise<any> => {
  const response = await axios.put(`${usersRoute}/${id}/user-type`, userObject);
  return response.data;
};

/* Find  user based on email */
export const getUserByEmail = async (
  email: any,
  actualUserId: any
): Promise<any> => {
  const response = await axios.get(`${usersRoute}/${email}/${actualUserId}`);
  return response.data;
};

/* Find  user based on email */
export const createUserAuditData = async (valuesObject: any): Promise<any> => {
  const response = await axios.post(`${usersAuditRoute}`, valuesObject);
  return response.data;
};

/* Find  user based on email */
export const updateUserAuditData = async (id: any): Promise<any> => {
  const response = await axios.put(`${usersAuditRoute}/${id}`);
  return response.data;
};

/* Find update user can impersonate */
export const updateUserCanImpersonate = async (
  id: any,
  userObject: any
): Promise<any> => {
  const response = await axios.put(
    `${usersRoute}/${id}/can-impersonate`,
    userObject
  );
  return response.data;
};